import UpcomingPage from './Upcoming';

export default UpcomingPage;
